import React, {useState, useEffect} from 'react'
import {withRouter} from 'react-router-dom'
import ARTUpload from '../../components/ART'
import ARTLogs from '../../components/ART/logs'
const ART = ()=>{
    return (
                <div className="container pt-4">
                  <h4 className="text-brand">ART Results Upload</h4>
                    <ARTUpload />
                    <ARTLogs />
                </div>
              )
    }
    export default withRouter(ART) 
